import { render, staticRenderFns } from "./newUserZone.vue?vue&type=template&id=f184e01c&scoped=true&"
import script from "./newUserZone.vue?vue&type=script&lang=js&"
export * from "./newUserZone.vue?vue&type=script&lang=js&"
import style0 from "./newUserZone.vue?vue&type=style&index=0&id=f184e01c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184e01c",
  null
  
)

export default component.exports